/* tslint:disable */
/* eslint-disable */
/**
 * Litiverse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProsecutionRoleEnum } from './ProsecutionRoleEnum';
import {
    ProsecutionRoleEnumFromJSON,
    ProsecutionRoleEnumFromJSONTyped,
    ProsecutionRoleEnumToJSON,
    ProsecutionRoleEnumToJSONTyped,
} from './ProsecutionRoleEnum';
import type { ProsecutionTypeEnum } from './ProsecutionTypeEnum';
import {
    ProsecutionTypeEnumFromJSON,
    ProsecutionTypeEnumFromJSONTyped,
    ProsecutionTypeEnumToJSON,
    ProsecutionTypeEnumToJSONTyped,
} from './ProsecutionTypeEnum';

/**
 * 
 * @export
 * @interface ProsecutionRoleUpdate
 */
export interface ProsecutionRoleUpdate {
    /**
     * One of 'LEAD', 'SUPERVISING', 'PARTICIPATING'
     * @type {ProsecutionRoleEnum}
     * @memberof ProsecutionRoleUpdate
     */
    role: ProsecutionRoleEnum;
    /**
     * One of 'LITIGATION', 'INVESTIGATION'
     * @type {ProsecutionTypeEnum}
     * @memberof ProsecutionRoleUpdate
     */
    type: ProsecutionTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof ProsecutionRoleUpdate
     */
    startDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ProsecutionRoleUpdate
     */
    endDate?: Date | null;
}



/**
 * Check if a given object implements the ProsecutionRoleUpdate interface.
 */
export function instanceOfProsecutionRoleUpdate(value: object): value is ProsecutionRoleUpdate {
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function ProsecutionRoleUpdateFromJSON(json: any): ProsecutionRoleUpdate {
    return ProsecutionRoleUpdateFromJSONTyped(json, false);
}

export function ProsecutionRoleUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProsecutionRoleUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'role': ProsecutionRoleEnumFromJSON(json['role']),
        'type': ProsecutionTypeEnumFromJSON(json['type']),
        'startDate': json['start_date'] == null ? undefined : (new Date(json['start_date'])),
        'endDate': json['end_date'] == null ? undefined : (new Date(json['end_date'])),
    };
}

export function ProsecutionRoleUpdateToJSON(json: any): ProsecutionRoleUpdate {
    return ProsecutionRoleUpdateToJSONTyped(json, false);
}

export function ProsecutionRoleUpdateToJSONTyped(value?: ProsecutionRoleUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'role': ProsecutionRoleEnumToJSON(value['role']),
        'type': ProsecutionTypeEnumToJSON(value['type']),
        'start_date': value['startDate'] == null ? undefined : ((value['startDate'] as any).toISOString().substring(0,10)),
        'end_date': value['endDate'] == null ? undefined : ((value['endDate'] as any).toISOString().substring(0,10)),
    };
}

